import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

const routeOptimizationScopes = [
  'tms:create',
  'tms:read',
  'tms:update',
  'tms:delete',
  'route-optimization:create',
  'route-optimization:read',
  'route-optimization:update',
  'route-optimization:delete',
]

export default [
  {
    path: '/route-optimization',
    name: 'Route Optimization',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(routeOptimizationScopes)

        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/route-optimization'),
  },
  {
    path: '/route-optimization/create',
    name: 'Route Optimization Create',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(routeOptimizationScopes)

        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/route-optimization/create'),
  },
  {
    path: '/route-optimization/:id',
    name: 'Route Optimization Detail',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(routeOptimizationScopes)

        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/route-optimization/detail'),
  },
  {
    path: '/route-optimization/:id/setting',
    name: 'Route Optimization Detail Setting',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(routeOptimizationScopes)

        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/route-optimization/setting'),
  },
  {
    path: '/route-optimization/:id/re-optimize',
    name: 'Route Reoptimization Setting',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const isVRPv2Enabled = getFeatureFlagValue('routeOptimizeVRPv2Flag')

        const acc = hasAccessAll(routeOptimizationScopes) && isVRPv2Enabled

        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/route-optimization/re-optimize'),
  },
]
